module.exports = __webpack_public_path__ + "static/media/playButtonImg.1341a488.svg";